export enum OptedQuantitySource {
  CEILING_LIMIT = 'CEILING_LIMIT',
  INHERITED = 'INHERITED',
  USER_OPTED = 'USER_OPTED',
}
